export default function toggleFilter() {
  var filter = $('.filterProduct');

  $('#toggleFilter').on('click', function () {
    if (!filter.hasClass('filterProduct--show'))
    filter.addClass('filterProduct--show');
  });
  
  $('.filterProduct__back').on('click', function () {
    if (filter.hasClass('filterProduct--show'))
    filter.removeClass('filterProduct--show');
  });
  
  $('.filterProduct__btnFilter').on('click', function () {
    if (filter.hasClass('filterProduct--show'))
      filter.removeClass('filterProduct--show');
  });
}